import { Component, OnInit } from '@angular/core';
import {UtilsService} from "../../shared/utils.service";

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    standalone: false
})
export class TermsComponent implements OnInit {

  constructor(private utils:UtilsService) { }

  ngOnInit(): void {
    this.utils.setTitle('Terms And Conditions');
  }

}
